
const concatContent = function(item) {
    const returnObject = { text: item.text }
    if (item.label) {
        returnObject.text = `<b>${item.label}</b> ${item.text}`
    }
    return returnObject
}

export default {
    name: 'product-info-tablist',
    data(){
        return {
            selectedTab: null,
            youtubeUrlPartOne: "https://www.youtube.com/embed/",
            youtubeUrlPartTwo: "?&amp;modestbranding=1&amp;rel=0&amp;showing=0&amp;color=white" 
        }
    },
    computed:{
        tablistData(){
            if (this.$store.state.main.productInfoTabs) {
                return this.$store.state.main.productInfoTabs
            }
        },
        tabContentData(){
            let returnData = []
            if (this.tablistData) {
                let temp = this.tablistData.filter(item => item.id === this.selectedTab)[0]
                if (temp && temp.content) {
                    returnData = temp.content.map(concatContent)
                }
            }
            return returnData
        },
        tabLinkData() {
            let returnData = []
            if (this.tablistData) {
                let temp = this.tablistData.filter(item => item.id === this.selectedTab)[0]
                if (temp && temp.links) {
                    returnData = temp.links
                }
            }
            return returnData
        },
        tabVideoData() {
            let returnData = ""
            if (this.tablistData) {
                let temp = this.tablistData.filter(item => item.id === this.selectedTab)[0]
                if (temp && temp.youtube) {
                    returnData = this.youtubeUrlPartOne + temp.youtube.youtubeLink + this.youtubeUrlPartTwo
                }
            }
            return returnData
        },
        tabNativeVideoData() {
            let returnData = null;
            if (this.tablistData) {
                let temp = this.tablistData.filter(item => item.id === this.selectedTab)[0]
                if(temp && temp.video) {
                    returnData = temp.video;
                    returnData.isStarted = false;

                    const onVideoClick = function(e) {
                        if(e.target.paused) { e.target.play(); temp.video.isStarted = true; }
                    }
                    const onVideoPause = function(e) {
                        if(!temp.video.isStarted) e.target.removeAttribute('controls');
                    }
                    const onVideoPlay = function(e) {
                        if(temp.video.showVideoControls) e.target.setAttribute("controls","controls");
                    }
                    
                    returnData.onVideoPlay = onVideoPlay;
                    returnData.onVideoPause = onVideoPause;
                    returnData.onVideoClick = onVideoClick;
                } else {
                    returnData = null;
                }
            }
            return returnData;
        }
    },
    methods: {
        activateTab(tabID) {
            this.selectedTab = tabID
        }
    },
    mounted: function() {
        if (this.tablistData) {
            this.activateTab(this.tablistData[0].id)
        }
    },
}